import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';
import { Link as LinkRoute } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { AppTheme } from '../styles/AppTheme';
import { AppConfig } from '../AppConfig';
import { ContactComponent } from '../components/ContactComponent';
import { AppHelper } from '../helpers/AppHelper';
import { CommonTheme, CommonStyles } from '../styles/Styles';
import { ContactUsFooter } from '../components/ContactUsFooter';

export class PublicFooter extends Component {

  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false
    }
    this.informationList = [
      {
        id: '1',
        to: '/about',
        titile: 'About Us',
      },
      /*{
        id: '2',
        to: '/',
        titile: 'Team',
      },*/
      {
        id: '3',
        to: '/terms',
        titile: 'Terms and Conditions',
      },
      {
        id: '4',
        to: '/privacy',
        titile: 'Privacy Policy',
      },
      {
        id: '5',
        to: 'https://www.blog.zepnurhealth.com/',
        newtab: true,
        titile: 'Blog',
      }
    ]
  }

  handleModal = () => {
    this.setState({
      modalVisible: !this.state.modalVisible,
    })
  }

  render() {
    return (
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.subContainer)}>
          <div className={css(Styles.container)}>
            <div className={css(Styles.contentOuterContainer)}>
              <div className={css(Styles.contentContainer)}>
                <p className={css(Styles.mainTitle)}>
                COMPANY
                </p>
                <div className={css(Styles.informationListContainer)}>
                  {this.informationList.map((item, index) => {
                    return (
                      <LinkRoute
                        key={item.id}
                        to={item.to}
                        target={item.newtab ? '_blank' : null}
                        className={css(Styles.terms)}>
                        <p className={css(Styles.contactDetailsTitleTerm)}>{item.titile}</p>
                      </LinkRoute>
                    )
                  })}
                </div>
              </div>
              <div className={css(Styles.ImgContainer)}>
                <img
                  src={require('../assets/images/logo.svg')}
                  className={css(Styles.logo)} />
              </div>
            </div>

            <div className={css(Styles.contentSecondOuterContainer)}>
              <ContactUsFooter
                cat={'FOOTER'}
                handleModal={this.handleModal}/>
            </div>

          </div>
          <p className={css(Styles.copyRightText)}>
            Copyright © {moment().year()} {AppConfig.COMPANY_NAME}  · All Rights Reserved
          </p>
          <p className={css(Styles.versionText)}>
            Version {AppConfig.VERSION}
          </p>
        </div>

        {this.state.modalVisible &&
          <ContactComponent
            modalVisible={this.state.modalVisible}
            handleModal={this.handleModal}
            contact={true}
          />
        }
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    backgroundColor: AppTheme.primaryBg,
    position: 'relative',
    borderTop: '1px solid lightgrey',
    padding: '30px 30px 30px 0px',
    display: 'flex',
    justifyContent: 'center',
    color: '#999999',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      paddingLeft: '30px'
    }
  },
  subContainer: {
    width: CommonTheme.webViewPort,
    alignSelf: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '@media (max-width: 767px)': {
      width: '100%'
    },
    '@media(max-width: 767px)': {
      width: CommonTheme.mobViewPort,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  contentOuterContainer: {
    display: 'flex',
    '@media (max-width: 767px)': {
      flexDirection: 'column',
    }
  },
  contentSecondOuterContainer: {
    marginTop: 30,
    '@media (max-width: 767px)': {
      marginTop: 20,
    }
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'flex-start',
    '@media (max-width: 767px)': {
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  mainTitle: {
    fontSize: 16,
    color: AppTheme.primaryColor,
    margin: '0px 0px 10px 0px',
    fontWeight: 'bolder',
    '@media (max-width: 767px)': {
      fontSize: 14,
    }
  },
  contactDetailsTitleTerm: {
    fontWeight: 'bolder',
    fontSize: 13,
    marginTop: 0,
    marginBottom: 10,
    color: CommonTheme.textColor,
    //marginRight: 45,
    '@media (max-width: 1024px)': {
      marginRight: 0,
    },
    '@media(max-width: 767px)': {
      fontSize: 12,
    },
  },
  terms: {
    marginRight: AppTheme.pagePadding * 4,
    textDecoration: 'none',
    '@media (max-width: 767px)': {
      marginRight: 0
    }
  },
  informationListContainer: {
    display: 'flex',
    flex: 1,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  copyRightText: {
    color: CommonTheme.textColor,
    fontSize: 13,
    textAlign: 'center',
    margin: '40px 0px 0px 0px',
    '@media (max-width: 767px)': {
      marginTop: 20,
      fontSize: 10,
    }
  },
  versionText: {
    color: CommonTheme.textColor,
    fontSize: 12,
    margin: 0,
    marginTop: 5
  },
  ImgContainer: {
    maxWidth: 150,
    alignSelf: 'flex-end',
    paddingTop: 30,
    '@media (max-width: 767px)': {
      paddingTop: 20,
    }
  },
  logo: {
    width: '100%',
    object: 'contain',
    marginBottom: 10,
    '@media (max-width: 767px)': {
      marginBottom: 0,
    }
  }
})


// WEBPACK FOOTER //
// ./src/components/PublicFooter.js